/*
 * @Author: WangZhengJie wangzj@geovis.com.cn
 * @Date: 2022-05-26 08:55:46
 * @LastEditors: WangZhengJie wangzj@geovis.com.cn
 * @LastEditTime: 2022-07-21 22:29:55
 * @FilePath: \ngtc-traceability-admin\src\app\interceptor\jwt.interceptor.ts
 * @Description:
 *
 * Copyright (c) 2022 by WangZhengJie wangzj@geovis.com.cn, Geovis All Rights Reserved.
 */
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let apiReq = req;
        // if (!req.url.startsWith('https') && !req.url.startsWith('http')) {
        //     const baseUrl = environment.apiServer.url;
        //     apiReq = req.clone({ url: `${baseUrl}${req.url}` });
        // }

        const token = localStorage.getItem('ACCESS_TOKEN');

        apiReq = apiReq.clone({
            headers: apiReq.headers.set('Authorization',  `Bearer ${token}`)
          });
        return next.handle(apiReq);
    }
}
